























import Vue from 'vue';
import { mapGetters } from 'vuex';
import { DoorConfiguration } from '../../../configurator/DoorConfiguration';

export default Vue.extend({
    name: 'RFrame',
    computed: {
    ...mapGetters('configuratorModule', ['getCurrentDoorConfiguration']),
        currentDoorConfiguration() {
            return this.getCurrentDoorConfiguration.Get(DoorConfiguration.Frame);
        }
    },
    methods: {
        
    },
    mounted() {
        
    }
})
